import {AxiosInstanceWithRefresh} from '../utils/AxiosConfig';

class AxiosInstance {
  constructor(useToken) {
    this.refreshing = false;
    this.queue = [];
    this.useToken = useToken;
    this.instance = AxiosInstanceWithRefresh({
      baseUrl: process.env.REACT_APP_BASE_ORIGIN_URL.replace('{origin}', window.location.origin),
    });
  }
  interceptors() {
    return this.instance.interceptors;
  }
  get(url, config) {
    return this.instance.get(url, config);
  }
  post(url, data, config) {
    return this.instance.post(url, data, config);
  }
  put(url, data, config) {
    return this.instance.put(url, data, config);
  }
  patch(url, data, config) {
    return this.instance.patch(url, data, config
    );
  }
  delete(url, config) {
    return this.instance.delete(url, config);
  }
  head(url, config) {
    return this.instance.head(url, config);
  }
  options(url, config) {
    return this.instance.options( url, config);
  }
  fetch(...args) {
    switch (args?.length) {
      case 1:
        const config = args[0];
        return this.instance(config);
      case 2:
        const url = args[0];
        const options = args[1];
        return this.instance(url, options);
      default:
        return Promise.reject();
    }
  }
}

export default AxiosInstance;
